<template>
  <Dialog dialog-classes="!max-w-md !p-4 md:!p-8">
    <template #trigger>
      <div class="flex justify-center">
        <CanvaCtaButton :image="props.image" />
      </div>
    </template>
    <template #content="{ closeDialog }">
      <div class="flex flex-col !pt-6 h-100 max-h-[680px]">
        <div class="text-center !px-0 md:!px-6 !mb-6">
          <Heading level="h4" class="mb-2 max-w-[20ch]">{{ I18n.t("canva_cta.common.design_anything") }}</Heading>
          <p class="text-typo text-sm !m-0">{{ I18n.t("canva_cta.common.design_anything_description") }}</p>
        </div>

        <div class="overflow-scroll hide-scrollbars flex-1 grid grid-cols-2 gap-4 !px-0 md:!px-6 !pb-6 h-100">
          <div v-for="document in documents" :key="document.meta.id" class="flex flex-col gap-2" @click="selectDocument(document.meta.id)" @keydown="selectDocument(document.meta.id)">
            <CanvaDocument :is-selected="isSelected(document.meta.id)" :meta="document.meta" :layers="document.layers" />
          </div>
        </div>
        <div class="flex flex-col gap-y-3 shadow-fold !px-0 md:!px-6 !pt-6">
          <Button full-width autofocus @click="handleClick(closeDialog)">{{ I18n.t("canva_cta.common.create") }}</Button>
          <p class="text-typo-secondary text-xs !m-0 text-center" v-html="tos_html"></p>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { computed, inject } from "vue";
import { Button, Dialog, Heading } from "prism";

import CanvaCtaButton from "./canva_cta_button.vue";
import CanvaDocument from "./canva_document.vue";
import { useCanvaDocuments } from "../../composables/canva_documents";

import { useCanvaLinkBuilder } from "../../composables/canva_link_builder";

const flavor = document.querySelector("meta[property='canva-env']").getAttribute("content");
const { buildUrl } = useCanvaLinkBuilder(flavor);

const I18n = inject("I18n", window.I18n);
const tos_html = I18n.t("canva_cta.common.tos_link_html", { link: "https://www.canva.com/policies/terms-of-use/" });

const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
});

const { documents, selectedDocument, selectDocument, isSelected } = useCanvaDocuments(props.image, props.width, props.height, I18n, flavor);

const computedUrl = computed(() => {
  return buildUrl(props.image, "b", selectedDocument.value);
});

const handleClick = (closeDialog) => {
  window.open(computedUrl.value, "_blank");
  closeDialog();
};
</script>

<style scoped>
.shadow-fold {
  box-shadow: 0 -5px 5px -3px rgba(14, 19, 24, 0.07);
}
</style>
